import { IconButton, Tooltip, useTheme } from '@mui/material'
import { GridColumns, GridNativeColTypes } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { MdDelete } from 'react-icons/md'
import { EmptyStatusCard } from 'src/components/mooring/EmptyStatusCard'
import GenericTable from 'src/components/table/GenericTable'
import { IResource } from 'src/generated-types/resource'
import { MUIThemeColors } from 'src/mui-theme'
import { Padding } from 'src/styles/paddingComponent'
import { getThemeColor } from 'src/utils'

interface TemporaryVesselTableProps {
  vessels: IResource[]
  scheduleTaskStartDate?: Date
  scheduleTaskEndDate?: Date
  setVessels?: React.Dispatch<React.SetStateAction<IResource[]>>
}
const TemporaryVesselTable = ({ scheduleTaskStartDate, scheduleTaskEndDate, vessels, setVessels }: TemporaryVesselTableProps) => {
  const { t: translate } = useTranslation(['task', 'common'])
  const theme = useTheme()

  const STATIC_COLUMNS: GridColumns = useMemo(
    () => [
      {
        field: 'name',
        headerName: translate('name', { ns: 'common' }),
        flex: 1,
        cellClassName: 'font-weight-semi-bold',
        renderCell: ({ row }) => row.resource.name,
      },
      {
        field: 'description',
        headerName: translate('description', { ns: 'common' }),
        flex: 1,
        renderCell: ({ row }) => row.description,
      },
    ],
    [],
  )
  
  const deleteVesel = (id: number) => {    
    if (setVessels) {
      setVessels(prevVessels => {
        const updatedVessels = prevVessels.filter(vessel => {
          return vessel.id !== id
        })
        return updatedVessels
      })
    }
  }

  const columns: GridColumns = useMemo(
    () => [
      ...STATIC_COLUMNS,
      {
        field: 'actions',
        headerName: '',
        type: 'actions' as GridNativeColTypes,
        width: 70,
        renderCell: ({ row }) => [
          <Tooltip title={`${translate('delete', { ns: 'common' })}`} key={'delete'}>
            <IconButton onClick={() => deleteVesel(row.id)}>
              <MdDelete size={24} />
            </IconButton>
          </Tooltip>,
        ],
      },
    ],
    [STATIC_COLUMNS, translate],
  )

  return (
    <Padding.p8
      marginTop={'8px'}
      border={`1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`}
      borderRadius={'4px'}
      bgcolor={getThemeColor(theme, MUIThemeColors.white)}
    >
      <GenericTable
        id="temporaryVessels"
        columns={columns}
        data={vessels}
        noDataComponent={() => (
          <EmptyStatusCard
            imageWidth="60px"
            contentFontSize="11px"
            headerFontSize="12px"
            content={translate('add-resource-empty-status-content', { ns: 'task' })}
            header={translate('add-resource-empty-status-title', { ns: 'task' })}
          />
        )}
        height={vessels.length > 2 ? '150px' : undefined}
        autoHeight={vessels.length <= 2}
        getRowHeight={() => 44}
      />
    </Padding.p8>
  )
}
export default TemporaryVesselTable
